import {backendApi} from "../../backend-api-sr"

export const gl_report = (() =>{

    const index = ( async (subPath) => {
        var url = '/api/accounting/gl-reporting/gl-detail-sum'
        if(subPath != null || subPath != ""){
            url = url + subPath;
        }
        return await backendApi.fetchCore(url, null, false, false, false)
    })

    const index_activity = ( async (subPath) => {
        var url = '/api/accounting/gl-reporting/gl-detail-activity'
        if(subPath != null || subPath != ""){
            url = url + subPath;
        }
        return await backendApi.fetchCore(url, null, false, false, false)
    })

    const index_activity_all = ( async (subPath) => {
        var url = '/api/accounting/gl-reporting/gl-detail-activity-all'
        if(subPath != null || subPath != ""){
            url = url + subPath;
        }
        return await backendApi.fetchCore(url, null, false, false, false)
    })

    const summary = ( async (subPath) => {
        var url = '/api/accounting/gl-reporting/gl-sum'
        if(subPath != null || subPath != ""){
            url = url + subPath;
        }
        return await backendApi.fetchCore(url, null, false, false, false)
    })

    const realisasi_vs_anggaran = ( async (subPath) => {
        var url = '/api/accounting/gl-reporting/budget-realisasi'
        if(subPath != null || subPath != ""){
            url = url + subPath;
        }
        return await backendApi.fetchCore(url, null, false, false, false)
    })

    // const show = ( async (subPath, reqBody) => {
    //     var url = '/api/accounting/gl-journal-voucher/show'
    //     if(subPath != null || subPath != ""){
    //         url = url + subPath;
    //     }
    //     return await backendApi.fetchCore(url, reqBody, false, false, false)
    // })

    return {index, index_activity, summary, realisasi_vs_anggaran, index_activity_all};

})()